import React from "react";
import { Link } from "react-router-dom";

export default function ArticleSidebar({ items, currentSlug, basePath, label }) {
  return (
    <nav aria-label="All articles" className="sticky top-24">
      <p className="font-arcade text-base text-[#15803D] uppercase tracking-wide mb-3">
        &gt; {label}
      </p>
      <ul className="space-y-2 border-l-2 border-[#D4D4D4] pl-4">
        {items.map((item) => {
          const isActive = item.slug === currentSlug;
          return (
            <li key={item.id}>
              <Link
                to={`${basePath}/${item.slug}`}
                className={`font-terminal text-xs leading-snug block transition-colors py-0.5 ${
                  isActive
                    ? "text-[#15803D] font-bold"
                    : "text-[#0A0A0A]/55 hover:text-[#15803D]"
                }`}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
